/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type ShipmentStatus = "DELIVERED" | "DRAFT" | "READY" | "SHIPPED";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ShipmentsTable_shipmentEdges$ref: FragmentReference;
declare export opaque type ShipmentsTable_shipmentEdges$fragmentType: ShipmentsTable_shipmentEdges$ref;
export type ShipmentsTable_shipmentEdges = $ReadOnlyArray<{|
  +node: {|
    +id: string,
    +shipmentNumber: string,
    +status: ShipmentStatus,
    +carrierName: ?string,
    +trackingNumber: ?string,
    +shippingMethod: ?string,
    +estimatedShipDate: ?any,
    +actualShipDate: ?any,
    +estimatedDeliveryDate: ?any,
    +actualDeliveryDate: ?any,
    +notes: ?string,
    +order: {|
      +id: string,
      +orderNumber: string,
    |},
    +customer: {|
      +id: string,
      +name: string,
    |},
    +createdAt: any,
    +updatedAt: any,
  |},
  +$refType: ShipmentsTable_shipmentEdges$ref,
|}>;
export type ShipmentsTable_shipmentEdges$data = ShipmentsTable_shipmentEdges;
export type ShipmentsTable_shipmentEdges$key = {
  +$data?: ShipmentsTable_shipmentEdges$data,
  +$fragmentRefs: ShipmentsTable_shipmentEdges$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ShipmentsTable_shipmentEdges",
  "type": "ShipmentEdge",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "Shipment",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "shipmentNumber",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "status",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "carrierName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "trackingNumber",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "shippingMethod",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "estimatedShipDate",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "actualShipDate",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "estimatedDeliveryDate",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "actualDeliveryDate",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "notes",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "order",
          "storageKey": null,
          "args": null,
          "concreteType": "Order",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "orderNumber",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "customer",
          "storageKey": null,
          "args": null,
          "concreteType": "Customer",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "createdAt",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "updatedAt",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '73d304527ed32fb89b514f16b7dece71';
module.exports = node;
